var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7323 10.5315L12.3523 2.14152C12.1623 1.95152 11.8523 1.95152 11.6623 2.14152L3.27227 10.5315C2.96227 10.8415 3.18227 11.3715 3.62227 11.3715H5.01227C5.14227 11.3715 5.26227 11.3215 5.36227 11.2315L11.0223 5.55152V21.5115C11.0223 21.7815 11.2423 22.0015 11.5123 22.0015H12.4923C12.7623 22.0015 12.9823 21.7815 12.9823 21.5115V5.55152L18.6523 11.2215C18.7423 11.3115 18.8723 11.3615 19.0023 11.3615H20.3823C20.8223 11.3615 21.0323 10.8315 20.7323 10.5215V10.5315Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboArrowUp);
export default __webpack_public_path__ + "static/media/FBOArrowUp.6785393708d02c4c69d8f5db67a7030b.svg";
export { ForwardRef as ReactComponent };